import { render } from "./NotificationUserResponseOptions.vue?vue&type=template&id=b86f26c2&scoped=true&ts=true"
import script from "./NotificationUserResponseOptions.vue?vue&type=script&lang=ts"
export * from "./NotificationUserResponseOptions.vue?vue&type=script&lang=ts"

import "./NotificationUserResponseOptions.vue?vue&type=style&index=0&id=b86f26c2&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b86f26c2"]])

export default __exports__